export default {
  plural: 'Accounting transactions',
  singular: 'Accounting transaction'
};
